import { useAtom } from 'jotai';
import { useState } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

import ModalImageVideo from '@/components/ModalImageVideo';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import {
  DataPopup,
  mergeDataPopup,
  popupsImageVideoAtom,
} from '@/store/popupImageVideo';
import {
  LinkEmbeddedFullTo,
  PopupVideoImagenTO,
} from '@/types/popupImageVideo';

export const PopupImageVideo = ({ popup }: { popup: DataPopup }) => {
  const { isMobile } = useIsDesktop();
  const navigate = useNavigate();
  const [popupsArray, setPopupsArray] = useAtom(popupsImageVideoAtom);
  const pp = popup.popup;
  const urlImg = getUrlImagen(pp, isMobile);
  const [showModal, setShowModal] = useState(true);

  function onClosePopup() {
    setShowModal(false);
    markPopupAsRead(popupsArray, setPopupsArray, popup);
  }
  if (!shouldShowPopupImageVideo(popup, false)) {
    return null;
  }
  return (
    <ModalImageVideo
      controlledOnClose={() => {
        onClosePopup();
      }}
      isControlledOpen={Boolean(
        shouldShowPopupImageVideo(popup, false) && showModal
      )}
      render={() => (
        <section className="relative border-1 border-[#870000] w-fit m-auto">
          <img
            alt="Imagen de popup"
            className="border-0 cursor-pointer max-h-screen"
            src={urlImg}
            onClick={() => {
              onClosePopup();
              UtilsLinkeable.onClickHandler(pp.linkData, navigate);
            }}
          />
        </section>
      )}
      size="auto"
      title={''}
      variant="controlled"
    />
  );
};

function getUrlImagen(pp: PopupVideoImagenTO, isMobile: boolean) {
  if (isMobile) {
    return pp.urlImagen || pp.urlImagenDesktop;
  } else {
    return pp.urlImagenDesktop || pp.urlImagen;
  }
}

const UtilsLinkeable = {
  ELinkeable: {
    EXTERNO: 2,
    INTERNO: 1,
    SIN_LINK: 3,
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  esLinkValido: function (linkData?: LinkEmbeddedFullTo) {
    return true;
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onClickHandler: function (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _linkData: LinkEmbeddedFullTo | undefined,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _navigate: NavigateFunction
  ) {
    // eslint-disable-next-line no-useless-return
    return;
  },
};

UtilsLinkeable.esLinkValido = function (linkData?: LinkEmbeddedFullTo) {
  'use strict';
  if (!linkData) return false;
  const ELinkeable = UtilsLinkeable.ELinkeable;
  if (linkData.idLinkeable === ELinkeable.SIN_LINK) {
    return false;
  }

  if (linkData.idLinkeable === ELinkeable.INTERNO) {
    return !!linkData.linkResp;
  }
  return true;
};

UtilsLinkeable.onClickHandler = function (
  linkData: LinkEmbeddedFullTo | undefined,
  navigate: NavigateFunction
) {
  'use strict';
  const ELinkeable = UtilsLinkeable.ELinkeable;

  const linkResp = linkData?.linkResp;

  if (!linkResp || !UtilsLinkeable.esLinkValido(linkData)) return;

  if (linkData.idLinkeable === ELinkeable.INTERNO) {
    // en un futuro: tracking.hitGTMPromo(promoOBJ, 'trackClickProm');
    navigate(linkResp);
  } else if (linkData.idLinkeable === ELinkeable.EXTERNO) {
    // en un futuro: tracking.hitGTMPromo(promoOBJ, 'trackClickProm');
    // puede ser un pdf, o un link a olé (promo suscripción olé)
    window.open(linkResp); // , '_blank'?
  }
};

export const EFrecuencia = {
  SIEMPRE: 1,
  UNICA_VEZ: 2,
  UNA_VEZ_X_SESION: 3,
};

export function isShownInLS(dataPopUp: DataPopup) {
  const nombreCookie = getPopupKey(dataPopUp);
  return localStorage.getItem(nombreCookie) !== null;
}

export function setShownInLS(dataPopUp: DataPopup) {
  localStorage.setItem(getPopupKey(dataPopUp), '1');
}

export function isShownInSS(dataPopUp: DataPopup) {
  const nombreCookie = getPopupKey(dataPopUp);
  return sessionStorage.getItem(nombreCookie) !== null;
}

export function setShownInSS(dataPopUp: DataPopup) {
  sessionStorage.setItem(getPopupKey(dataPopUp), '1');
}

function getPopupKey(dataPopUp: DataPopup) {
  return (
    'pp_' +
    dataPopUp.idUsuarioDT +
    '_' +
    dataPopUp.fecha +
    '_' +
    dataPopUp.popup?.id +
    '_' +
    dataPopUp?.popup?.idModulo
  );
}

function markPopupAsRead(
  popupsArray: DataPopup[],
  setPopupsArray: (
    args_0: DataPopup[] | ((prev: DataPopup[]) => DataPopup[])
  ) => void,
  pp: DataPopup
) {
  const showAlways = pp.popup?.idFrecuencia === EFrecuencia.SIEMPRE;

  if (pp.popup?.idFrecuencia === EFrecuencia.UNICA_VEZ) {
    setShownInLS(pp);
  } else if (pp.popup?.idFrecuencia === EFrecuencia.UNA_VEZ_X_SESION) {
    setShownInSS(pp);
  }
  pp.seMostro = !showAlways;
  const newPopupsArray = mergeDataPopup(popupsArray, pp);
  setPopupsArray([...newPopupsArray.map((popup) => ({ ...popup }))]);
}

export function shouldShowPopupImageVideo(
  dataPopUp: DataPopup,
  mostrarSiempre: boolean
) {
  if (mostrarSiempre) {
    return true;
  }

  const yaSeMostro = dataPopUp.seMostro;

  if (dataPopUp.popup?.idFrecuencia === EFrecuencia.UNICA_VEZ) {
    return !isShownInLS(dataPopUp) && !yaSeMostro; // !yaSeMostro || ..
  } else if (dataPopUp.popup?.idFrecuencia === EFrecuencia.UNA_VEZ_X_SESION) {
    return !isShownInSS(dataPopUp) && !yaSeMostro;
  } else {
    return true;
  }
}

/**
 * Limpia los popups del sessionStorage.
 * (llamar en el logout, por ejemplo)
 */
export function clearPopupsSS() {
  for (const key of Object.keys(sessionStorage)) {
    if (key.startsWith('pp_')) {
      sessionStorage.removeItem(key);
    }
  }
}
